/* Copyright (c) 2020-present CloudIO Inc */

import { Item } from 'componentregistry';

export const page: {
  root: Item<'Page'>;
  drawer: Item<'Drawer'>;
  flexPanel: Item<'FlexPanel'>;
  flexItem: Item<'FlexItem'>;
  flexItem1: Item<'FlexItem'>;
  toolbar: Item<'Toolbar'>;
  typography: Item<'Typography'>;
  submitButton: Item<'Button'>;
  triggerOnClick: Item<'TriggerOnClick'>;
  toolbarFiller: Item<'ToolbarSpacer'>;
  timesIconButton: Item<'IconButton'>;
  triggerOnClick1: Item<'TriggerOnClick'>;
  closeDrawer: Item<'ActionCloseDrawer'>;
  flexPanel1: Item<'FlexPanel'>;
  flexItem2: Item<'FlexItem'>;
  openDrawerButton: Item<'Button'>;
  triggerOnClick2: Item<'TriggerOnClick'>;
  openDrawer: Item<'ActionOpenDrawer'>;
  closeDrawer1: Item<'ActionCloseDrawer'>;
} = {
  closeDrawer: {
    children: [],
    itemId: 'closeDrawer',
    parent: 'triggerOnClick1',
    props: {
      targetItemId: 'drawer',
    },
    type: 'ActionCloseDrawer',
  },
  closeDrawer1: {
    children: [],
    itemId: 'closeDrawer1',
    parent: 'triggerOnClick',
    props: {
      targetItemId: 'drawer',
    },
    type: 'ActionCloseDrawer',
  },
  drawer: {
    children: ['flexPanel'],
    itemId: 'drawer',
    parent: 'root',
    props: {
      modal: true,
      open: false,
    },
    type: 'Drawer',
  },
  flexItem: {
    children: ['toolbar'],
    itemId: 'flexItem',
    parent: 'flexPanel',
    props: {
      padding: {
        all: 8,
      },
      sizeType: 'auto',
    },
    type: 'FlexItem',
  },
  flexItem1: {
    children: [],
    itemId: 'flexItem1',
    parent: 'flexPanel',
    props: {},
    type: 'FlexItem',
  },
  flexItem2: {
    children: ['openDrawerButton'],
    itemId: 'flexItem2',
    parent: 'flexPanel1',
    props: {},
    type: 'FlexItem',
  },
  flexPanel: {
    children: ['flexItem', 'flexItem1'],
    itemId: 'flexPanel',
    parent: 'drawer',
    props: {},
    type: 'FlexPanel',
  },
  flexPanel1: {
    children: ['flexItem2'],
    itemId: 'flexPanel1',
    parent: 'root',
    props: {},
    type: 'FlexPanel',
  },
  openDrawer: {
    children: [],
    itemId: 'openDrawer',
    parent: 'triggerOnClick2',
    props: {
      targetItemId: 'drawer',
    },
    type: 'ActionOpenDrawer',
  },
  openDrawerButton: {
    children: ['triggerOnClick2'],
    itemId: 'openDrawerButton',
    parent: 'flexItem2',
    props: {
      startIcon: {
        iconName: 'window-restore',
        iconType: 'light',
      },
      text: {
        type: 'text',
        value: 'Open Drawer',
      },
    },
    type: 'Button',
  },
  root: {
    children: ['drawer', 'flexPanel1'],
    itemId: 'root',
    parent: 'root',
    props: {
      backgroundColor: 'paper',
      windowTitle: {
        type: 'text',
        value: 'Page with Drawer',
      },
    },
    type: 'Page',
  },
  submitButton: {
    children: ['triggerOnClick'],
    itemId: 'submitButton',
    parent: 'toolbar',
    props: {
      startIcon: {
        iconName: 'check',
        iconType: 'light',
      },
      text: {
        type: 'text',
        value: 'Submit',
      },
    },
    type: 'Button',
  },
  timesIconButton: {
    children: ['triggerOnClick1'],
    itemId: 'timesIconButton',
    parent: 'toolbar',
    props: {
      icon: {
        iconName: 'times',
        iconType: 'light',
      },
      toolTip: {
        type: 'text',
        value: 'Close',
      },
    },
    type: 'IconButton',
  },
  toolbar: {
    children: [
      'typography',
      'toolbarFiller',
      'submitButton',
      'timesIconButton',
    ],
    itemId: 'toolbar',
    parent: 'flexItem',
    props: {},
    type: 'Toolbar',
  },
  toolbarFiller: {
    children: [],
    itemId: 'toolbarFiller',
    parent: 'toolbar',
    props: {},
    type: 'ToolbarSpacer',
  },
  triggerOnClick: {
    children: ['closeDrawer1'],
    itemId: 'triggerOnClick',
    parent: 'submitButton',
    props: {},
    type: 'TriggerOnClick',
  },
  triggerOnClick1: {
    children: ['closeDrawer'],
    itemId: 'triggerOnClick1',
    parent: 'timesIconButton',
    props: {},
    type: 'TriggerOnClick',
  },
  triggerOnClick2: {
    children: ['openDrawer'],
    itemId: 'triggerOnClick2',
    parent: 'openDrawerButton',
    props: {},
    type: 'TriggerOnClick',
  },
  typography: {
    children: [],
    itemId: 'typography',
    parent: 'toolbar',
    props: {
      text: {
        type: 'text',
        value: 'Some Title',
      },
    },
    type: 'Typography',
  },
};
